<template>
  <div class="container container-body error-container">
    <div class="case orange-gradient">
      <p>Oops !</p>
      <p v-if="error.trim() != ''">{{ error }}</p>
      <p v-if="apiError.trim() != ''">{{ apiError }}</p>
      <p v-else>One error occured</p>
    </div>
    <i class="image fa fa-search"></i>
    <app-scan-another-code></app-scan-another-code>
  </div>
</template>

<script>
import ScanAnotherCode from '../buttons/ScanAnotherCode.vue'

export default {
  props: ['error', 'apiError'],
  components: {
    AppScanAnotherCode: ScanAnotherCode
  }
}
</script>

<style lang="scss" scoped>
  .error-container {
    position: relative;
  }

  .case {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    -webkit-display: flex;
    -webkit-flex-direction: column;
    -webkit-align-items: center;
    border-radius: 10px;width: 90%;
    -webkit-border-radius: 10px;width: 90%;
    max-width: 400px;
    margin: 15px;
    color: white;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1.1px;
    text-align: center;
    max-height: 200px;
    overflow: hidden;
  }

  .image {
    position: absolute;
    bottom: 80px;
    font-size: 50px;
    color: #464A53;
    animation: error 3s ease-out forwards infinite;
    -webkit-animation: error 3s ease-out forwards infinite;

     @media screen and (max-width: 320px) {
      font-size: 40px;
      bottom: 60px;
    }
  }
  
  @keyframes error {
    0% {
      transform: rotate(0DEG);
      -webkit-transform: rotate(0DEG);
    }
    5% {
      transform: rotate(5DEG);
      -webkit-transform: rotate(5DEG);
    }
    10% {
      transform: rotate(-15DEG);
      -webkit-transform: rotate(-15DEG);
    }
    15% {
      transform: rotate(5DEG);
      -webkit-transform: rotate(5DEG);
    }
    20% {
      transform: rotate(-15DEG);
      -webkit-transform: rotate(-15DEG);
    }
    30% {
      transform: rotate(5DEG);
      -webkit-transform: rotate(5DEG);
    }
    40% {
      transform: rotate(0DEG);
      -webkit-transform: rotate(0DEG);
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/Error.vue